export const LOBBY_ROOT = 'lobby/';

// Actions types
export const GET_ORG_NEWS = 'getOrgNews';
export const GET_HELP_DESK_DETAILS = 'getHelpDeskDetails';
export const CHANGE_PASSWORD = 'changePassword';
export const PERFORM_DATA_CLEANSING = 'performDataCleansing';
export const UPDATE_USER_DETAILS = 'updateUserDetails';
export const GET_USER_DETAILS = 'getUserDetails';
export const LOBBY_ACCESSIBLE = 'lobbyAccessible';
export const GET_CHANGES_NOTIFICATION_FLAG = 'getChangesNotificationFlag';

// Getters types
export const ORG_NEWS = 'orgNews';
export const HELP_DESK_DETAILS = 'helpDeskDetails';
export const CHANGE_PASSWORD_ERRORS = 'changePasswordErrors';
export const USER_DATA_CLEANSING_ERRORS = 'userDataCleansingErrors';
export const LOBBY_SUCCESS_DIALOG = 'lobbySuccessDialog';
export const MUST_PERFORM_DATA_CLEANSING = 'mustPerformDataCleansing';
export const USER_PERFORM_DATA_CLEANSING = 'userPerformDataCleansing';
export const PERFORM_CHANGE_PASSWORD = 'performChangePassword';
export const MUST_CHANGE_PASSWORD = 'mustChangePassword';
export const PERFORM_DATA_CLEANSING_ERRORS = 'performDataCleansingErrors';
export const CHANGE_PASSWORD_LOADING = 'changePasswordLoading';
export const CHANGE_USER_DATA_CLEANSING_LOADING = 'changeUserDataCleansingLoading';
export const INDEX_AND_OFFICES_LIST = 'indexAndOfficesList';
export const UPLOAD_FILE_ENABLE = 'uploadFileEnable';
export const OPEN_POPUP_CHANGES_NOTIFICATION_FLAG = 'openPopupChangesNotificationFlag';

// Mutations types
export const SET_ORG_NEWS = 'setOrgNews';
export const SET_HELP_DESK_DETAILS = 'setHelpDeskDetails';
export const SET_CHANGE_PASSWORD_ERRORS = 'setChangePasswordErrors';
export const SET_USER_PERFORM_DATA_CLEANSING = 'setUserPerformDataCleansing';
export const SET_PERFORM_CHANGE_PASSWORD = 'setPerformChangePassword';
export const SET_USER_DATA_CLEANSING_ERRORS = 'setUserDataCleansingErrors';
export const SET_LOBBY_SUCCESS_DIALOG = 'setLobbySuccessDialog';
export const SET_MUST_PERFORM_DATA_CLEANSING = 'setMustPerformDataCleansing';
export const SET_MUST_CHANGE_PASSWORD = 'setMustChangePassword';
export const SET_PERFORM_DATA_CLEANSING_ERRORS = 'setPerformDataCleansingErrors';
export const SET_CHANGE_PASSWORD_LOADING = 'setChangePasswordLoading';
export const SET_CHANGE_USER_DATA_CLEANSING_LOADING = 'setChangeUserDataCleansingLoading';
export const SET_INDEX_AND_OFFICES_LIST = 'setIndexAndOfficesList';
export const SET_UPLOAD_FILE_ENABLE = 'setUploadFileEnable';
export const SET_OPEN_POPUP_CHANGES_NOTIFICATION_FLAG = 'setOpenPopupChangesNotificationFlag';
